var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("label",function(){return [_c('label',[_vm._v(_vm._s(_vm.label))])]},{"label":_vm.label}),_vm._v(" "),_vm._t("value",function(){return [_c('p',[_vm._v(_vm._s(_vm.value || _vm.t('default::label.unknown')))])]},{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }